module.exports = __webpack_public_path__ + "static/media/pop_X.a0337dc4.svg";